<template>
  <div class="page">
    <!-- 筛选 -->
    <div class="filter">
      <el-input
        placeholder="请输入内容"
        v-model="keyword"
        clearable
        prefix-icon="el-icon-search"
        class="sousuo"
        size="small"
      >
      </el-input>
      <el-button type="warning" @click="handelComClick" size="small"
        >搜索</el-button
      >
      <div class="filterName">分类：</div>
      <el-select
        v-model="applyType"
        placeholder="请选择"
        class="titleSelect"
        style="width: 118px"
        size="small"
        @change="handelComClick"
      >
        <el-option
          v-for="item in applyTypes"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <div class="filterName">亡故日期：</div>
      <el-date-picker
        v-model="deathDate"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="small"
        style="width: 220px"
        @change="handelComClick"
      >
      </el-date-picker>
      <div class="filterName" v-if="shopType == 0">门店：</div>
      <el-select
        v-model="shopId"
        placeholder="请选择"
        class="titleSelect"
        style="width: 100px"
        size="small"
        @change="handelComClick"
        v-if="shopType == 0"
      >
        <el-option
          v-for="item in shops"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
      <el-button
        type="warning"
        plain
        size="small"
        style="margin-left: 20px"
        @click="resetClick"
        >重置</el-button
      >
      <el-button
        type="warning"
        plain
        size="small"
        style="margin-left: 20px"
        @click="exprot"
        >导出</el-button
      >
    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="feedShop.name" label="门店" width="80">
        <template slot-scope="scope" v-if="scope.row.feedShop != null">
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr10'"
            >驯养中心</span
          >
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr11'"
            >小程序</span
          >
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr12'"
            >金水区店</span
          >
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr14'"
            >指挥中心</span
          >
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr16'"
            >拓展部</span
          >
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr17'"
            >线上店</span
          >
          <span v-if="scope.row.feedShop.id == '5e9412e0b2bfbc089daerr18'"
            >郑东新区店</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="deathTime" label="亡故日期" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.deathTime == null || scope.row.deathTime == ''"
            >--</span
          >
          <span v-else>{{
            $public.FTime(scope.row.deathTime, "YYYY-MM-DD")
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="applyType.title" label="分类" width="50">
      </el-table-column>
      <el-table-column prop="breedInfo.name" label="品种" width="120">
        <template slot-scope="scope">
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.breedInfo.name"
            placement="right"
          >
            <span>{{ scope.row.breedInfo.name }}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" width="80">
        <template slot-scope="scope">
          <span>{{ scope.row.age }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="epromNo" label="芯片编号" width="150">
      </el-table-column>
      <el-table-column prop="insideNo" label="脖圈号" width="150">
      </el-table-column>
      <el-table-column label="操作人" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.deathOperInfo == null">--</span>
          <span v-else>{{ scope.row.deathOperInfo.handle_name }}</span>
        </template>
      </el-table-column>
      <el-table-column label="原因">
        <template slot-scope="scope">
          <span v-if="scope.row.deathReason == null">--</span>
          <el-tooltip
            class="item"
            effect="dark"
            :content="scope.row.deathReason"
            placement="left"
            v-else
          >
            <span
              style="
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
              "
              >{{ scope.row.deathReason }}</span
            >
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="60" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handelNavClick(scope.row)"
            >详情</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <page
      :total="page.total"
      :page="page.page"
      @change="changePage"
      style="margin-top: 22px"
    ></page>
  </div>
</template>

<script>
import axios from "axios";
import page from "@/components/page.vue";
import { deaths } from "@/api/purchaseApi.js";
export default {
  components: {
    page,
  },
  props: {
    shopType: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      page: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      tableData: [],
      applyType: "0", //分类数据
      applyTypes: [
        {
          value: "0",
          label: "全部",
        },
        {
          value: "1",
          label: "猫类",
        },
        {
          value: "2",
          label: "犬类",
        },
      ],
      keyword: "", //列表搜索内容
      deathDate: "", //亡故日期
      shops: [
        {
          value: "",
          label: "全部",
        },
        {
          value: "5e9412e0b2bfbc089daerr12",
          label: "金水区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr14",
          label: "指挥中心",
        },
        {
          value: "5e9412e0b2bfbc089daerr16",
          label: "拓展部",
        },
        {
          value: "5e9412e0b2bfbc089daerr18",
          label: "郑东新区店",
        },
        {
          value: "5e9412e0b2bfbc089daerr10",
          label: "驯养中心",
        },
      ],
      shopId: "", //门店id
    };
  },
  mounted() {
    this.getTableData();
  },
  methods: {
    // 导出
    exprot() {
      let params = {
        keyword: this.keyword,
        applyType: this.applyType,
        shopId: this.shopId,
      };
      if (this.deathDate != "") {
        params.startTime = new Date(this.deathDate[0]).getTime() / 1000;
        params.endTime = new Date(this.deathDate[1]).getTime() / 1000;
      }
      console.log(params);
      axios
        .get(
          process.env.VUE_APP_Url2 + "api/product/pet/death/list/export",

          { params, responseType: "blob" }
        )
        .then((response) => {
          console.log(response.data, "地址");
          var href = window.URL.createObjectURL(response.data); //创建下载的链接
          var downloadElement = document.createElement("a");
          downloadElement.href = href;
          downloadElement.download = "亡故动物导出.xlsx";
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
          this.resetClick();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //筛选
    handelComClick() {
      this.page.page = 1;
      this.getTableData();
    },
    formatChu(a) {
      if (a < 12) {
        return a + "个月";
      }
      if (a == 12) {
        return "1岁";
      } else {
        var n1 = Math.floor(a / 12);
        var n2 = a % 12;
        console.log(a, n1, n2);
        return n1 + "岁" + n2 + "个月";
      }
    },
    //跳转
    handelNavClick(row) {
      let query = {
        id: row._id,
      };
      this.$router.push({
        path: "detail",
        query,
      });
    },

    //重置数据
    resetClick() {
      this.page.page = 1;
      this.keyword = "";
      this.applyType = "0";
      this.deathDate = "";
      if (this.shopType == 0) {
        this.shopId = "";
      }
      this.getTableData();
    },
    //获取数据
    getTableData() {
      let params = {
        pageIndex: this.page.page,
        pageSize: this.page.pageSize,
        keyword: this.keyword,
        applyType: this.applyType,
      };
      if (this.shopType == 0) {
        params.shopId = this.shopId;
      } else {
        params.shopId = this.$store.state.shopId;
      }
      if (this.deathDate != "") {
        params.startTime = new Date(this.deathDate[0]).getTime() / 1000;
        params.endTime = new Date(this.deathDate[1]).getTime() / 1000;
      }
      deaths(params).then((res) => {
        if (res.code == 0) {
          console.log("死亡列表", res);
          this.tableData = res.data.data;
          this.page.total = res.data.count;
        }
      });
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.page {
  min-height: 762px;
  background: #fff;
  margin-top: 12px;
  font-size: 14px;

  .filter {
    height: 58px;
    display: flex;
    align-items: center;

    .sousuo {
      width: 153px;
      margin-right: 4px;
      margin-left: 16px;
    }

    .filterName {
      margin-left: 20px;
      margin-right: 4px;
    }
  }
}
</style>
